import React from 'react';
import type { SignatureStatus } from '../types/contract.types';

const STATUS_LABEL: Record<Exclude<SignatureStatus, null>, string> = {
  handwritten: 'Manuscrite',
  signed: 'Signée',
  canceled: 'Annulée',
  pending: 'Envoyée',
  failed: 'Échec',
};

const STATUS_COLOR_CLASS: Record<Exclude<SignatureStatus, null>, string> = {
  handwritten: 'tw-text-blue-600',
  signed: 'tw-text-green-600',
  canceled: 'tw-text-red-600',
  pending: 'tw-text-orange-500',
  failed: 'tw-text-red-700',
};

export const signatureStatusLabel = (status: SignatureStatus): string =>
  status ? STATUS_LABEL[status] : '-';

export const signatureStatusColorClass = (status: SignatureStatus): string =>
  status ? STATUS_COLOR_CLASS[status] : '';

interface Props {
  status: SignatureStatus;
}

export const SignatureStatusBadge: React.FC<Props> = ({ status }) => {
  if (!status) return <>-</>;
  return (
    <span className={`${STATUS_COLOR_CLASS[status]} tw-font-medium`}>
      {STATUS_LABEL[status]}
    </span>
  );
};
